// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"08efde4a","220":"7eb50526","355":"5692dd5d","390":"85bc8bd1","453":"a9a577cb","577":"345ab9a6","975":"de48eb87"}[chunkId] + ".chunk.js";
};